module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0063.jpg?v=fed4242c";